import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NavComponent } from '../../components/nav.component/nav.component';
import { FooterComponent } from '../../components/footer.component/footer.component';

@Component({
  selector: 'app-terms.component',
  imports: [
    CommonModule,
    RouterModule,
    NavComponent,
    FooterComponent,
  ],
  templateUrl: './terms.component.html',
  styleUrl: './terms.component.scss',
})
export class TermsComponent {
  lastUpdated = 'October 10, 2026';
}
